import React, { useState } from 'react';
import { Button, Card, CardContent, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { NoteService } from '../../Services/note.service';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import RHFTextArea from '../../components/hook-form/RHFTextArea';

const EventSchema = Yup.object().shape({
  code: Yup.string().required('Code không đươc để trống'),
  note: Yup.string().required('Note không được để trống').max(500),
});

const CreateNote = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [image, setImage] = useState();
  const [imageReview, setImageReview] = useState();

  const defaultValues = {
    code: '',
  };

  const methods = useForm({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleOnSubmit = (data) => {
    const form = new FormData();
    form.append('code', data.code);
    form.append('note', data.note);
    form.append('image', image);
    NoteService.CreateNote(form)
      .then((res) => {
        navigate('/notes', { replace: true, state: '/notes' });
        enqueueSnackbar('Thêm note mới thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }));
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const handleAvatarChange = (e) => {
    try {
      const img = e.target.files[0];
      const review = URL.createObjectURL(img);
      setImageReview(review);
      setImage(img);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Page title="Create note">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Thêm note mới
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Button
                type="button"
                onClick={handleCancelClick}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="iconoir:cancel" />}
              >
                Cancel
              </Button>
              <Button disabled={isSubmitting} type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                Save
              </Button>
            </Stack>
          </Stack>
          <Card>
            <CardContent>
              <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                <Grid item xs={12} md={8}>
                  <Stack spacing={2}>
                    <RHFTextField name="code" label={'Code'} />
                    <RHFTextArea name="note" label={'Ghi chú'} />
                  </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    // disabled={isSubmitting}
                    sx={{ border: '1px dashed gray' }}
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input onChange={handleAvatarChange} hidden accept="image/*" type="file" />
                    {imageReview ? (
                      <img
                        src={imageReview}
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <img
                        src="/static/noimage.jpeg"
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                  </Button>
                  <Typography variant="body2" display="block" sx={{ opacity: '0.6' }}>
                    Kích thước: 500x760
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </FormProvider>
    </Page>
  );
};

export default CreateNote;
